module.exports = __webpack_public_path__ + "img/07-illu-matome2021.e130784f.jpg";